import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CreateUserRequest, CreateUserResponse } from '../../interfaces/create-user.interface';

import { Global } from '../global';

@Injectable({
  providedIn: 'root'
})
export class CreateUserService {

  private readonly API_URL: string;

  constructor(private readonly httpClient: HttpClient) {
    this.API_URL = Global.url + '/auth';
  }

  createUser(request: CreateUserRequest): Observable<CreateUserResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.httpClient.post<CreateUserResponse>(this.API_URL + '/create_user', request, { headers });
  }

  getUserPendingOfRole(): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.httpClient.get<any>(`${this.API_URL}/pending_requests`, { headers: headers, withCredentials: true })
  }

  updateRoleUser(email: string, rol: string): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.httpClient.post<any>(`${this.API_URL}/update_role`, { email, rol }, { headers: headers, withCredentials: true })
  }

  rejectRequest(email: string): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.httpClient.delete<any>(`${this.API_URL}/reject_request`, {
      headers: headers,
      body: { email },
      withCredentials: true
    })
  }

  private getAuthHeaders(): HttpHeaders {
    const token = localStorage.getItem('authToken');
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    });
  }
}
